import Vue from 'vue'
import Router from 'vue-router'
import MealNum from '@/components/MealNum'
import New_MealNum from '@/components/New_MealNum'
import ShopInfo from '@/components/ShopInfo'

import Dishes from '@/components/Dishes'
import DishDetail from '@/components/DishDetail'
import PackageDetail from '@/components/PackageDetail'
import PackageEdit from '@/components/PackageEdit'
import OrderDetail from '@/components/OrderDetail'
import Success from '@/components/Success'
import Fail from '@/components/Fail'
import CashPayment from '@/components/CashPayment'
import newDishes from '@/components/newDishes'

import Home from '@/reserve/Home'
import InputInfo from '@/reserve/InputInfo'
import Result from '@/reserve/Result'
import ContactUs from '@/reserve/ContactUs'

import InputBookInfo from '@/service/InputBookInfo'
import BookResult from '@/service/BookResult'

import Address from '@/takeAway/Address'
import TakeDishes from '@/takeAway/TakeDishes'
import TakeDishDetail from '@/takeAway/TakeDishDetail'
import TakePackageDetail from '@/takeAway/TakePackageDetail'
import TakeCartDetail from '@/takeAway/TakeCartDetail'
import TakeOrderDetail from '@/takeAway/TakeOrderDetail'
import OrderStatus from '@/takeAway/OrderStatus'
import PayFail from '@/takeAway/PayFail'
import PaySuccess from '@/takeAway/PaySuccess'
import TakeCashPayment from '@/takeAway/TakeCashPayment'

import E_Dishes from '@/e_menu/Dishes'
import E_DishDetail from '@/e_menu/DishDetail'
import E_PackageDetail from '@/e_menu/PackageDetail'

import PackDishes from '@/packDishes/PackDishes'
import PackDishesDetail from '@/packDishes/PackDishesDetail'
import PackageDishesDetail from '@/packDishes/PackageDishesDetail'
import PackOrderDetail from '@/packDishes/PackOrderDetail'
import PackOrderList from '@/packDishes/PackOrderList'


Vue.use(Router)

export default new Router({
  routes: [{
      path: '/:storeId/:placeId/:code',
      name: 'MealNum',
      component: MealNum
    },
    {
      path: '/New/:storeId/:placeId/:code',
      name: 'New_MealNum',
      component: New_MealNum
    },
    {
      path: '/ShopInfo/:id',
      name: 'ShopInfo',
      component: ShopInfo
    },
    {
      path: '/Dishes',
      name: 'Dishes',
      component: Dishes,
      meta: {
        keepAlive: false // 缓存标识
      }
    },
    {
      path: '/DishDetail/:id',
      name: 'DishDetail',
      component: DishDetail,
      meta: {
        keepAlive: false // 缓存标识
      }
    },
    {
      path: '/PackageDetail/:id',
      name: 'PackageDetail',
      component: PackageDetail
    },
    {
      path: '/PackageEdit/:id',
      name: 'PackageEdit',
      component: PackageEdit
    },
    {
      path: '/OrderDetail/:id',
      name: 'OrderDetail',
      component: OrderDetail,
      meta: {
        keepAlive: false // 缓存标识
      }
    },
    {
      path: '/Home/:id/:category/:code',
      name: 'Home',
      component: Home
    },
    {
      path: '/InputInfo',
      name: 'InputInfo',
      component: InputInfo
    },
    {
      path: '/Result',
      name: 'Result',
      component: Result
    }, {
      path: '/ContactUs',
      name: 'ContactUs',
      component: ContactUs
    }, {
      path: '/InputBookInfo',
      name: 'InputBookInfo',
      component: InputBookInfo
    }, {
      path: '/BookResult',
      name: 'BookResult',
      component: BookResult
    }, {
      path: '/Success',
      name: 'Success',
      component: Success
    }, {
      path: '/Fail',
      name: 'Fail',
      component: Fail
    }, {
      path: '/CashPayment',
      name: 'CashPayment',
      component: CashPayment
    }, {
      path: '/Address',
      name: 'Address',
      component: Address
    }, {
      path: '/TakeDishes',
      name: 'TakeDishes',
      component: TakeDishes,
      meta: {
        keepAlive: false // 缓存标识
      }
    }, {
      path: '/TakeDishDetail/:id',
      name: 'TakeDishDetail',
      component: TakeDishDetail,
      meta: {
        keepAlive: false // 缓存标识
      }
    }, {
      path: '/TakePackageDetail/:id',
      name: 'TakePackageDetail',
      component: TakePackageDetail
    }, {
      path: '/TakeCartDetail',
      name: 'TakeCartDetail',
      component: TakeCartDetail
    }, {
      path: '/TakeOrderDetail/:id',
      name: 'TakeOrderDetail',
      component: TakeOrderDetail
    }, {
      path: '/OrderStatus',
      name: 'OrderStatus',
      component: OrderStatus
    }, {
      path: '/PayFail',
      name: 'PayFail',
      component: PayFail
    }, {
      path: '/PaySuccess',
      name: 'PaySuccess',
      component: PaySuccess
    }, {
      path: '/TakeCashPayment',
      name: 'TakeCashPayment',
      component: TakeCashPayment
    },
    {
      path: '/E_Dishes',
      name: 'E_Dishes',
      component: E_Dishes
    },
    {
      path: '/E_DishDetail/:id',
      name: 'E_DishDetail',
      component: E_DishDetail
    },
    {
      path: '/E_PackageDetail/:id',
      name: 'E_PackageDetail',
      component: E_PackageDetail
    },
    {
      path: '/newDishes',
      name: 'newDishes',
      component: newDishes
    },
    {
      path: '/PackDishes',
      name: 'PackDishes',
      component: PackDishes
    },
    {
      path: '/PackDishesDetail/:id',
      name: 'PackDishesDetail',
      component: PackDishesDetail
    },
    {
      path: '/PackageDishesDetail/:id',
      name: 'PackageDishesDetail',
      component: PackageDishesDetail
    },
    {
      path: '/PackOrderDetail/:id',
      name: 'PackOrderDetail',
      component: PackOrderDetail
    },
    {
      path: '/PackOrderList',
      name: 'PackOrderList',
      component: PackOrderList
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js